import React from "react";
import { history } from "router";
import { Button } from "antd";
import { getDataFromQueryString } from "../utils";

const EntityNameLink = (entity_name, record) => {
    return (
        <a
            href={`/entity/${encodeURI(entity_name)}?id=${record.key}&&type=${
                record.type
            }`}
            onClick={e => e.preventDefault()}
        >
            {entity_name}
        </a>
    );
};

export const previousCaseIdLink = (_) => {
    return (
        <a
            href={window.location.protocol+"//"+window.location.host+"/app/inbox/"+_+"/previous_cases"}
        >
            {`PGCP-${_}`}
        </a>
    );
};

export const createEntityNameLink = () =>
    function EntityNameLink(entity_name, record, caseOpenedFromDrawer=false, caseOpenFromDecisioningDashboard = false, caseOpenedFromPaymentProgram = false,) {
        let caseDetails = {
            caseOpenedFromDrawer
        };
        let pathname = window.location.pathname.split("/")[2];
        if(window.location.pathname.includes("/case/new")) {
            pathname = "inbox";
        }
        let record_id = record.id;
        if(caseOpenFromDecisioningDashboard) {
            record_id = record["Case Id"].replace("PGCP-", "");
        }
        return (
            <Button 
                type={"link"} 
                size={"small"}
                style={{
                    padding: 0,
                    color: "#246079",
                    fontWeight: 600,
                    cursor: "pointer"
                }}
                onClick={() =>
                    history.push(
                        `/app/${pathname}/${
                            record_id
                        }/${caseOpenedFromPaymentProgram ? 
                            `case_checklist?ordering=${getDataFromQueryString("ordering")}&onboarding_id=${record.onboarding_id}&dealer_name=${record.dealer_name}`
                            : "credit_summary"
                        }`,
                        {
                            case_details: caseDetails
                        }
                    )
                }
            >
                {entity_name}
            </Button>
        );
    };

export default EntityNameLink;
